import type { DetalheChamado } from '../../../types/chamado'

/** A integração roda de 30 em 30 minutos; três horas sem passar por um chamado aberto não é atraso. */
const TOLERANCIA_EM_MS = 3 * 60 * 60 * 1000

/**
 * O chamado aberto parou de ser atualizado pela integração?
 *
 * Achado de 26/10/2026: a conta de serviço do e-Niterói não é membro dos grupos de especialista da
 * contratada (RH, Tributário, Financeiro, Patrimonial, Portal Transparência), e a busca devolve zero
 * chamado deles. O chamado transferido para um desses grupos simplesmente some da busca e fica
 * congelado no último estado visto — o 2026081437 constava "Pendente" aqui e estava fechado desde
 * 04/09 no e-Niterói. Eram 47 nessa situação. A correção de fundo é do administrador do e-Niterói;
 * esta função é o que impede a tela de afirmar como atual um estado de semanas atrás.
 *
 * @param chamado o chamado
 * @param agora o instante de referência
 * @returns verdadeiro quando o chamado é da integração, está aberto e a última coleta é antiga
 */
export function parouDeAtualizar(
  chamado: Pick<DetalheChamado, 'origem' | 'fechadoEm' | 'coletadoEm'>,
  agora: Date,
): boolean {
  if (chamado.origem !== 'GLPI_REST' || chamado.fechadoEm) {
    return false
  }
  const coletado = Date.parse(chamado.coletadoEm)
  return Number.isFinite(coletado) && agora.getTime() - coletado > TOLERANCIA_EM_MS
}
